export default __webpack_public_path__ + "images/aeba41f8b9387f96bfe78a9cc090ad83-first_aid_small.webp";